import { createSelector } from 'reselect';

import { State } from './reducer';

const getState = (state: any): State => state.market;

export const getMarketByCoinId = (coinId: string) =>
  createSelector([getState], (state) => state.data[coinId] || {});
